import { render, staticRenderFns } from "./purchaseCarriage.vue?vue&type=template&id=7bd3ae1c"
import script from "./purchaseCarriage.vue?vue&type=script&lang=js"
export * from "./purchaseCarriage.vue?vue&type=script&lang=js"
import style0 from "./purchaseCarriage.vue?vue&type=style&index=0&id=7bd3ae1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports